import { z } from "zod"
import { CustomerContactDetailsSchema } from "../customer"

export const JobCustomerSchema = CustomerContactDetailsSchema.extend({
  id: z.string().uuid(),
  isClubMember: z.boolean(),
  jobId: z.string().uuid(),
})
export type JobCustomer = z.infer<typeof JobCustomerSchema>
